import { VAppBar } from 'vuetify/lib/components/VAppBar';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loggedIn)?_c(VAppBar,{staticClass:"time-position d-flex justify-center",attrs:{"dark":"","color":"accent","app":"","fixed":"","dense":""}},[_vm._v("\n  "+_vm._s(_vm.time)+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }